<h1 mat-dialog-title>{{'PROJECT.INITIAL.PROGRESS.TITLE' | anessaTranslation: trigger}}</h1>
<mat-dialog-content>
  <app-progress-popup-dialog
    *ngIf="showProgress"
    [dataIn]="dataIn">
  </app-progress-popup-dialog>
</mat-dialog-content>
<mat-dialog-actions>
  <mat-checkbox class="validation-checkbox" [(ngModel)]="validationAccepted">
    {{'PROJECT.INITIAL.PROGRESS.CHECKBOX' | anessaTranslation: trigger}}
  </mat-checkbox>
  <div class="action-buttons">
    <button
      mat-button
      class="btn-fat btn-green"
      type="button"
      [disabled]="!validationAccepted"
      (click)="onSubmitClick()">
      {{'PROJECT.COMMON.SUBMIT' | anessaTranslation: trigger}}
    </button>
    <button
      mat-button
      class="btn-fat btn-red"
      type="button"
      (click)="onCancelClick()">
      {{'PROJECT.COMMON.CANCEL' | anessaTranslation: trigger}}
    </button>
  </div>
</mat-dialog-actions>
